import { IStackTokens } from '@fluentui/react';

export class FormHelper {
    static verticalStackTokens = {
        standard: {
            childrenGap: 20,
        } as IStackTokens,
        compact: {
            childrenGap: 10,
        } as IStackTokens,
    };

    static horizontalStackTokens = {
        standard: {
            childrenGap: 40,
        } as IStackTokens,
        compact: {
            childrenGap: 10,
        } as IStackTokens,
    };

    static inlineContainer = {
        margin: 10,
    } as React.CSSProperties;
}
